<template>
  <div class="h-full">
    <RouterView />
    <Notification></Notification>
    <BoosterPromoModal></BoosterPromoModal>
    <ModalsContainer class="modals-container" />
    <SupportBtn />
  </div>
</template>

<script lang="ts" setup>
import BoosterPromoModal from '@/components/booster-promo-modal/BoosterPromoModal.vue';
import Notification from '@/components/notification/Notification.vue';
import SupportBtn from '@/components/support-btn/SupportBtn.vue';
import { useUnusedCreditsModal } from '@/components/unused-credits-email-modal/hooks/use-unused-credits-modal/use-unused-credits-modal';
import a2hs from '@/helpers/a2hs/a2hs';
import { createDevUser } from '@/helpers/development/createDevUser';
import { toggleActivityFavicon } from '@/helpers/favicon/favicon';
import { trackCameBack } from '@/helpers/track-came-back/track-came-back';
import { trackWebPushReferrer } from '@/helpers/webpush/webpush';
import { startHandleConversionsInterval } from '@/pages/payment/helpers/payment-websocket/helpers/conversion/conversion';
import { CommonStateIndex } from '@/store/modules/common/common-state';
import { getStore, Mutation } from '@/store/store-helper';

import { trackFirstVisitFromLanding } from './helpers/track-first-visit/track-first-visit';

getStore().subscribe(({ type, payload }: { type: keyof Mutation; payload: CommonStateIndex }) => {
  if (type === 'mutationCommonSetState') {
    toggleActivityFavicon(payload.newChatMessagesCount > 0 || payload.hasNewActivity);
  }
});

startHandleConversionsInterval();

useUnusedCreditsModal().showCreditsPromoPopup();

trackCameBack();
trackWebPushReferrer();
trackFirstVisitFromLanding();

if (import.meta.env.DEV) {
  (window as any).createDevUser = createDevUser;
}

a2hs.init();
</script>
